module.exports = __webpack_public_path__ + "img/nav-bg-home.28129701.png";